import React, { useState } from 'react';
import { themeActuel, definirTheme } from './theme';

/**
 * Bouton de bascule clair / sombre.
 * Le libellé annonce ce qui se passera au clic, pas l'état courant :
 * en thème clair, il propose « Sombre ».
 */
function ThemeToggle({ compact = false }) {
  const [theme, setTheme] = useState(themeActuel);

  const basculer = () => {
    setTheme(definirTheme(theme === 'dark' ? 'light' : 'dark'));
  };

  const versSombre = theme !== 'dark';

  return (
    <button
      type="button"
      className={`btn theme-toggle${compact ? ' theme-toggle-compact' : ''}`}
      onClick={basculer}
      title={versSombre ? 'Passer en thème sombre' : 'Passer en thème clair'}
      aria-label={versSombre ? 'Passer en thème sombre' : 'Passer en thème clair'}
    >
      <span className="theme-toggle-icon" aria-hidden="true">
        {versSombre ? (
          // Lune
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
        ) : (
          // Soleil
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
          </svg>
        )}
      </span>
      {!compact && <span className="theme-toggle-label">{versSombre ? 'Sombre' : 'Clair'}</span>}
    </button>
  );
}

export default ThemeToggle;
